import { Card, Tabs } from 'antd';
import Snapshots from './Snapshots';
import ZendeskAttachments from './ZendeskAttachments';

const AttachmentsPage = () => {
  const tabItems = [
    {
      label: 'Zendesk',
      key: 'zendesk',
      children: <ZendeskAttachments />,
    },
    {
      label: 'Snapshots',
      key: 'snapshots',
      children: <Snapshots />,
    },
  ];

  return (
    <Card title="Attachments">
      <Tabs items={tabItems} />
    </Card>
  );
};

export default AttachmentsPage;
